import React, {useState, useRef} from "react";
import Typography from "@mui/material/Typography";
import {Box, Link, Popover} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Timeout = NodeJS.Timeout;
import {SxProps} from "@mui/system";
import {palette} from "../../technical/style/theme";

export function InfoIcon(props: {text: string, color?: string, sx?: SxProps}) {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const infoText = props.text;
  const timeoutHandle = useRef<Timeout | undefined>();

  const handlePopoverOpen = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget);
    if (timeoutHandle.current) {
      clearTimeout(timeoutHandle.current);
      timeoutHandle.current = undefined;
      setAnchorEl(null);
    } else {
      timeoutHandle.current = setTimeout(() => {
        setAnchorEl(null);
      }, 5000);
    }
  };

  const handlePopoverClose = () => {
    if (timeoutHandle.current) {
      clearTimeout(timeoutHandle.current);
      timeoutHandle.current = undefined;
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (!infoText) {
    return null;
  }

  return (
    <Box sx={props.sx}>
      <InfoOutlinedIcon
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onClick={handlePopoverOpen}
        sx={{color: palette.borderColor}}
      />
      <Popover
        id="mouse-over-popover"
        open={open}
        sx={{
          pointerEvents: 'none',
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
      >
        <div>
          {infoText.split("\n").map((line, key) => {
            if (line.startsWith("http://") || line.startsWith("https://")) {
              return (
                <Link href={line} target="_blank" key={key} sx={{p: 1, textAlign: "left", pointerEvents: 'auto'}}>
                  {line || "\u00A0"}
                </Link>
              );
            }
            return (
              <Typography key={key} variant={"body2"} sx={{p: 1, textAlign: "left", color: props.color || "red"}}>
                {line || "\u00A0"}
              </Typography>
            );
          })}
        </div>
      </Popover>
    </Box>
  );
}
